
    import Vue from "vue";
    // Components
    import RomaOa from "./RomaOa.vue";
    // Store
    import UnitPlanOa from "@/store/planner/objetive/UnitPlanOa";
    import UnitPlanComments from '@/store/units/UnitPlanComments';
import { mapState } from 'vuex';
    import _ from "lodash";
import { sub } from "date-fns";

    // @ts-ignore
    export default Vue.extend({
        name: "RomaOaModalForm",
        async created(): void {
            await this.getCategoriesAndSubjects();
            this.getOAsBySubjectId();
        },
        props: {
            value: Boolean,
            unit: {
                type: Object,
                required: true
            },
            maxWidth: {
                type: String,
                default: "90%"
            },
            overlayOpacity: {
                type: String,
                default: "0.8"
            },
            persistent: {
                type: Boolean,
                default: true
            }
        },
        watch: {
            value: async function(val) {
                if(val)
                {
                    this.getOAsBySubjectId();
                }

            }
        },
        computed: {
            ...mapState({
                prioridades: state => state.roma.prioridades,
            }),
        },
        data() {
            return {
                valid: false,
                loading: false,
                showing: this.value,
                oaView: RomaOa,
                subject: null,
                schoolLevel: null,
                course: null,
                availableSubjects: [],
                availableLevels: [],
                educations: [],
                oas: [],
                request: {
                    oas: []
                },
                priority: '',
            };
        },
        methods: {
            getSelectedSchoolYear(){
                return JSON.parse(localStorage.getItem('roma')) && JSON.parse(localStorage.getItem('roma')).organizer &&
                    JSON.parse(localStorage.getItem('roma')).organizer.selectedSchool ?
                    JSON.parse(localStorage.getItem('roma')).organizer.selectedSchool.yearSelected : null;
            },
            async getCategoriesAndSubjects() {         
                const year = this.getSelectedSchoolYear()? this.getSelectedSchoolYear() : new Date().getFullYear();
                const response = await this.$store.dispatch("getSectionWithSubjects", year);
                const secciones = response.data.content.secciones;
                let educationList = secciones.map((section: any) => {
                    return section.categoria.educacion.nombre;
                });
                //remove duplicates from educationList
                educationList = educationList.filter((item, index) => educationList.indexOf(item) === index);
                let educationListWithCategories = educationList.map((education: any) => {
                    let educationSections = secciones.filter((section: any) => section.categoria.educacion.nombre === education);
                    let categories = educationSections.map((section: any) => {
                        return {
                            id: section.categoria.id,
                            name: section.categoria.nombre,
                            subjects: section.subjects.map((subject: any) => {
                                return {
                                    id: subject.id,
                                    name: subject.name,
                                    cod: subject.cod
                                }
                            })
                        }
                    });

                    let categoriesUnique = _.uniqBy(categories, 'id');
                    categoriesUnique = categoriesUnique.map((category: any) => {
                        let subjectsUnique: any = [];
                        categories.forEach((category2: any) => {
                            if (category.id === category2.id) {
                                subjectsUnique = subjectsUnique.concat(category2.subjects);
                            }
                        });
                        subjectsUnique = _.uniqBy(subjectsUnique, 'id');
                        category.subjects = subjectsUnique;
                        return category;
                    });

                    return {
                        name: education,
                        categories: categories
                    }
                });
                const levels: any[] = [];
                this.educations = educationListWithCategories;

                educationListWithCategories.forEach((education: any)=>{
                    levels.push({
                        header: education.name,
                    });
                    education.categories.forEach((category: any)=>{
                        levels.push(category);
                    });
                })

                this.availableLevels = levels;

                this.schoolLevel = this.availableLevels.find(
                    (education: any) => education.id === this.unit.id_nivel
                );

                this.subject = this.schoolLevel.subjects.find(
                    (subject: any) => subject.id === this.unit.id_asignatura
                );
                this.priority = this.unit.priority ? this.unit.priority : null;
               
            },
            changeCategoryEvent(){
                if(this.schoolLevel){
                    if(this.schoolLevel.subjects.find((subject: any) => subject.id === this.subject.id) == null){
                        this.subject = this.schoolLevel.subjects[0];
                    }
                    this.getOAsBySubjectId();
                }
            },
            selectOAs(event) {
                this.request.oas = event;
            },
            setUnit() {
                this.loading = true;
                const oasMapped = this.request.oas.map(details => {
                    return {
                        id: details.oa.id,
                        idIndicadoresEvaluacion: details.selectedRows
                            .filter(ie => ie.oa_id === details.oa.id)
                            .map(ie => ie.id)
                    };
                });
                this.$store
                    .dispatch("addUnitPlanOAComplement", {
                        idPlanUnidad: this.unit.id,
                        oas: oasMapped
                    })
                    .then(response => {
                        let msj = {
                            show: true,
                            text: "",
                            color: "success"
                        };
                        if (
                            response.data &&
                            response.data.status &&
                            response.data.status.code === 1
                        ) {
                            UnitPlanOa.insertOrUpdate({ data: response.data.content.oas });
                            
                            //this.unit.oa_count += this.request.oas.length;
                            this.unit.updateStatus(response.data.content.status);
                            this.unit.updatePercentages(response.data.content.percentages);
                            const commentsToInsert = response.data.content.comment.filter((comment: any) => !!comment);
                            if (commentsToInsert.length > 0) UnitPlanComments.insert({ data: commentsToInsert });
                            msj.text = this.$vuetify.lang.t('$vuetify.component.romaOAModalForm.endpointMessages.addedObjectiveSuccess');
                            this.show(false);
                            this.request.oas = [];
                            this.getOAsBySubjectId();
                            this.course = null;
                        } else if (
                            response.data &&
                            response.data.status &&
                            response.data.status.code === 3
                        ) {
                            msj.text = response.data.content.message;
                            msj.color = "red";
                        }

                        if (!!msj.text) this.$store.state.snackbar = msj;

                    }).catch((error: any) => {
                        this.$store.state.snackbar = {
                            show: true,
                            color: 'red',
                            text: 'Ha ocurrido un error al agregar objetivos',
                        };
                        console.error("Error al obtener objetivos para añadir", error);
                    }).finally(() => {
                        this.loading = false;
                    });
            },
            show(value) {
                this.$emit("input", value);
            },
            getOAsBySubjectId() {

                if (this.schoolLevel && this.subject) {
                    this.loading = true;
                    this.request.oas = [];

                    let request = new URLSearchParams(
                        `idCategoria=${this.schoolLevel.id}&idAsignatura=${this.subject.id}&idPlanUnidad=${this.unit.id}&prioridad=${this.priority ? this.priority : ''}`
                    );

                    this.$store.dispatch("romaOAsBySubjectId", request).then(response => {
                        const oas = response.data.content.map(oa => {
                            return new UnitPlanOa({
                                id: oa.id * 2,
                                unitplan_id: this.unit.id,
                                oa_id: oa.id,
                                oa: oa,
                                selectedRows: []
                            });
                        });
                        this.oas = { details: oas };

                    }).catch((error: any) => {
                        this.$store.state.snackbar = {
                            show: true,
                            color: 'red',
                            text: 'Ha ocurrido un error al obtener los objetivos a agregar',
                        };
                        console.error("Error al obtener objetivos para añadir", error);

                    }).finally(() => {
                        this.loading = false;
                    });
                }
            }
        }
    });
